import { IconProps, iconA11yProps } from '../types';

export const ArrowLeft = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" {...iconA11yProps(label)}>
        <path
            d="M9,3.24V12.76c0,.88-1.05,1.33-1.68,.73L2.24,8.73c-.42-.4-.42-1.06,0-1.46L7.32,2.51c.64-.6,1.68-.15,1.68,.73Z"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
    </svg>
);
